import { createReducer, on } from '@ngrx/store';
import { get, save } from 'src/app/data/utils/localstorage.util';
import { TdcApplicationState } from 'src/app/models/state/tdc-application-state.model';
import { TdcAplicationActions } from '../actions/tdc-application.actions';

const TDC_APPLICATION_KEY = 'TdcApplicationState';

export const initialState: TdcApplicationState = {
	applicationId: 0,
	evaluation: null,
	hasSavedDebitCardOption: false,
};

const getInitialState = (initialState): TdcApplicationState => {
	const stateFromLocalStorage = get<TdcApplicationState>(TDC_APPLICATION_KEY);
	if (stateFromLocalStorage !== null) {
		return stateFromLocalStorage;
	}

	return initialState;
};

export const tdcApplicationReducer = createReducer(
	getInitialState(initialState),
	on(
		TdcAplicationActions.addTdcApplication,
		(state, { applicationId, evaluation }): TdcApplicationState => {
			const newState: TdcApplicationState = {
				...state,
				applicationId,
				evaluation,
			};
			saveSateToLocalStorage(newState);
			return newState;
		}
	),
	on(
		TdcAplicationActions.addHasSaveDebitCardOption,
		(state): TdcApplicationState => {
			const newState: TdcApplicationState = {
				...state,
				hasSavedDebitCardOption: true,
			};

			saveSateToLocalStorage(newState);
			return newState;
		}
	)
);

function saveSateToLocalStorage(newState: TdcApplicationState) {
	save(TDC_APPLICATION_KEY, newState);
}
